import { ChartData } from 'chart.js';
import { StocksOnHandBySector } from '../../models/dashboard';
import LineChart from '../ui/LineChart';
import { useEffect, useState } from 'react';
import { generateLastSixMonthsLabels } from '../../helper/date-helper';
import { IndustryColorsForPiechart } from '../../constants/charts.constant';

const ProfitLossByIndustryPerMonthCard = ({ data }: PropsType) => {
  const [chartData, setChartData] = useState<ChartData | null>(null);
  useEffect(() => {
    if (!data) return;

    const chartData = {
      labels: generateLastSixMonthsLabels(),
      datasets: data.map((d) => {
        return {
          label: d.sector,
          data: d.recentMonthlyProfit,
          borderColor: IndustryColorsForPiechart[d.sector].hover,
          backgroundColor: 'rgba(0, 0, 0, 0)', // Transparent background
          borderWidth: 2,
          tension: 0.1,
        };
      }),
    };

    setChartData(chartData);
  }, [data]);

  return (
    <div className="flex flex-col col-span-full sm:col-span-12 xl:col-span-4 bg-white shadow-lg rounded-sm border border-slate-200">
      <header className="px-5 py-4 border-b border-slate-100 flex items-center">
        <h2 className="font-semibold text-slate-800">
          Monthly Earnings by Industry
        </h2>
      </header>

      {/* Chart built with Chart.js 3 */}
      <div className="grow">
        {/* Change the height attribute to adjust the chart height */}
        {chartData && <LineChart data={chartData} width={389} height={262} />}
      </div>
    </div>
  );
};

type PropsType = {
  data: StocksOnHandBySector[];
};

export default ProfitLossByIndustryPerMonthCard;
